// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.halfWidthContainer_VKHWn {
  width: calc(50% - (var(--size-padLarge) / 2))
}

.text_wW1yl {
  padding-top: 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/components/UserForm.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".halfWidthContainer {\n  width: calc(50% - (var(--size-padLarge) / 2))\n}\n\n.text {\n  padding-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"halfWidthContainer": `halfWidthContainer_VKHWn`,
	"text": `text_wW1yl`
};
export default ___CSS_LOADER_EXPORT___;
